import axios from "axios";

// Toujours appeler l'API sur la même origine que le frontend :
// - En prod (juris-flash.com ou case-urgence.emergent.host) → same-origin, zéro CORS
// - En preview (preview.emergentagent.com) → same-origin également
// - Fallback SSR/build : variable env
const runtimeOrigin = typeof window !== "undefined" && window.location?.origin;
export const BACKEND_URL = runtimeOrigin || process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CASE_TYPES = [
  { value: "bail_litige", label: "Logement / Bail locatif" },
  { value: "stationnement_fps", label: "Stationnement / FPS" },
  { value: "consommation", label: "Consommation & Factures" },
  { value: "travail", label: "Litige Travail / Contrat" },
];

// Modèle éco 2026 — 3 offres cohérentes avec le produit (frontend only, Stripe frozen)
export const PLANS = {
  scan_gratuit: { name: "Scan & Structuration express", price: "0 €", desc: "Contrôle de complétude et qualification factuelle en 47 secondes", cta: "Essayer gratuitement" },
  pack_resolution: { name: "Pack Résolution Citoyen", price: "8,99 €", desc: "Mise en demeure + modèle type personnalisé, prêt à envoyer", cta: "Débloquer le Pack" },
  pro_monthly: { name: "Espace Pro B2B", price: "49 €/mois", desc: "Gestionnaires et syndics : pré-instruction illimitée + historique", cta: "S'abonner Pro" },
  // Legacy plans conservés pour compatibilité endpoints paiement existants (backend frozen)
  lrar_letter: { name: "Mise en Demeure LRAR", price: "8,99 €", desc: "Lettre recommandée officielle La Poste / AR24 avec preuve de dépôt", cta: "Envoyer la LRAR" },
};
